'use strict';

// Bootstrap components used on every page; the others come with the modules that use them.
import Collapse from 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';

import '../styles/index.scss';

import './components/dropdowns';
import './components/forms';
import './components/modal';
import './components/reviews';

import {consent} from "./components/consent/consent";
import { watchTriggers } from './triggers';
import { isMobile } from './components/_helpers';
const { CONSENT_STORAGE_NAME } = require('./components/consent/constants/consentStorageName');

// Inline scripts that use the bundle wait for the parklot:ready event on document (scripts in the page run
// before the deferred bundle) or for window.parklot.ready.
let markReady;
window.parklot = { ready: new Promise((resolve) => { markReady = resolve; }) };

// Whether the element is rendered, that is neither it nor an ancestor has display: none.
function isRendered(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', function(event) {
        const button = event.target.closest('label.tree-toggler');
        if (!button) return;
        const submenu = button.parentElement.querySelector(':scope > ul.tree');
        const items = submenu ? submenu.querySelectorAll('.submenu-dropdown') : [];
        const open = !submenu?.classList.contains('show');

        if (submenu) {
            submenu.classList.toggle('show', open);
            submenu.style.display = open ? '' : 'none';
        }
        items.forEach((item) => {
            item.setAttribute('tabindex', open ? '0' : '-1');
            item.classList.toggle('dropdown-item', open);
        });
        button.setAttribute('aria-expanded', String(open));
        event.stopPropagation();
    });

    document.addEventListener('keydown', function(event) {
        const button = event.target.closest('label.tree-toggler');
        if (button && (event.key === 'Enter' || event.keyCode === 13 || event.which === 13)) {
            event.preventDefault();
            button.click();
            event.stopPropagation();
        }
    });

    let isEscapeClose = false;


    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && [...document.querySelectorAll('.modal')].some(isRendered)) {
            isEscapeClose = true;
        }
    });

    document.addEventListener('hidden.bs.modal', function(e) {
        if (isEscapeClose && e.target.closest('.modal')) {
            try {
                const triggerId = e.target.getAttribute('triggerElement');
                if (triggerId) {
                    const triggeredElement = document.querySelector(`[data-trigger-id="${triggerId}"]`);
                    if (triggeredElement) {
                        triggeredElement.focus();
                    }
                }
            } catch (error) {
                console.log('Nie udało się przywrócić focusu');
            } finally {
                isEscapeClose = false;
            }
        }
    });


    // analytics
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
        Object.assign(
            {
                event: 'consent_default'
            },
            consent.getDeniedValues.getConsentDeniedValues()
        )
    );

    if (typeof CONSENT_STORAGE_NAME !== 'undefined' && window.localStorage.getItem(CONSENT_STORAGE_NAME) === null) {
        window.dataLayer.push(
            Object.assign(
                {
                    event: 'page_view'
                },
                {
                    virtual_page: window.location.href
                }
            )
        );
    }
    // Header dropdowns marked .dropdown--auto open on hover on desktop.
    if (!isMobile()) {
        // mouseenter and mouseleave don't bubble, so the body listens in the capture phase.
        const hover = function(e) {
            if (!e.target.matches('.dropdown.dropdown--auto')) return;
            const dropdown = e.target.closest('.dropdown');
            dropdown.classList.add('show');

            setTimeout(() => {
                const hovered = dropdown.matches(':hover');
                dropdown.classList.toggle('show', hovered);
                dropdown.querySelectorAll('[data-toggle="dropdown"]').forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', hovered);
                });
            }, 200);
        };
        document.body.addEventListener('mouseenter', hover, true);
        document.body.addEventListener('mouseleave', hover, true);
    }

    document.querySelectorAll('.dropdown-submenu .dropdown-toggle').forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            let target = document.querySelector(this.getAttribute('data-bs-target'));
            let bsCollapse = Collapse.getInstance(target);
            if (!bsCollapse) {
                bsCollapse = new Collapse(target, { toggle: true });
            } else {
                bsCollapse.toggle();
            }
        });
    });

    watchTriggers().then(() => {
        markReady();
        document.dispatchEvent(new Event('parklot:ready'));
    });
});

window.addEventListener('load', function () {
    consent.init.runAfterConsent();
});